import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Bath, Ruler, MapPin, Heart } from "lucide-react";
import { fmtPrice, fmtNum, typeLabel, photoSrc } from "./homesUtil";
import { useSaved } from "@/context/SavedContext";

export function PropertyCard({ listing }) {
  const l = listing;
  const rent = l.status === "for_rent";
  const photo = l.photos?.[0];
  const saved = useSaved();
  const isSaved = saved?.isSaved(l.id);
  return (
    <Link to={`/homes/property/${l.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-[#0F172A]/10 bg-white transition-all hover:-translate-y-1 hover:shadow-xl"
      data-testid={`property-card-${l.id}`}>
      <div className="relative h-48 w-full overflow-hidden bg-[#0F172A]/5">
        {photo ? (
          <img src={photoSrc(photo, true)} alt={l.address} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-[#0F172A]/30"><MapPin className="h-8 w-8" /></div>
        )}
        <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white ${rent ? "bg-[#0F172A]" : "bg-[#2563EB]"}`}>
          {rent ? "For Rent" : "For Sale"}
        </span>
        {saved && (
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); saved.toggle(l.id); }}
            className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 shadow transition-transform hover:scale-110"
            data-testid={`save-btn-${l.id}`} aria-label="Save home">
            <Heart className={`h-4 w-4 ${isSaved ? "fill-[#2563EB] text-[#2563EB]" : "text-slate-500"}`} />
          </button>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="text-2xl font-black text-[#0F172A]">{fmtPrice(l.price, rent)}</div>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#334155]/70">
          {l.beds > 0 && <span className="flex items-center gap-1"><BedDouble className="h-4 w-4 text-[#2563EB]" /> {l.beds} bd</span>}
          {l.baths > 0 && <span className="flex items-center gap-1"><Bath className="h-4 w-4 text-[#2563EB]" /> {l.baths} ba</span>}
          {l.sqft && <span className="flex items-center gap-1"><Ruler className="h-4 w-4 text-[#2563EB]" /> {fmtNum(l.sqft)} sqft</span>}
        </div>
        <div className="mt-2 text-sm font-medium text-[#334155]">{l.address}</div>
        <div className="text-xs text-[#334155]/60">{l.city_name}, {l.state_name}</div>
        <div className="mt-auto pt-3 text-[11px] font-semibold uppercase tracking-wider text-[#0F172A]/50">{typeLabel(l.property_type)}{l.sample ? " · Sample" : ""}</div>
      </div>
    </Link>
  );
}
